import React, { useState, useEffect } from 'react';
import ErpTemplate from '../../components/ErpTemplate';
import { FaSave } from 'react-icons/fa';
import api from '../../services/api';
import { useHistory } from 'react-router-dom';
import SaveButton from '../../components/SaveButton';
import { toast } from 'react-toastify';


export default function CadastroProdutoTipoAtributo({ match }) {
    const id = match.params.id;
    const empresa = localStorage.getItem("empresa");
    const token = localStorage.getItem('token');
    const [dados, setDados] = useState([]);
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [isLoading, setIsLoading] = useState(!!id);
    const history = useHistory();

    const buscar = () => {
        setIsLoading(true);
        if (id) {
            api({
                method: "get",
                action: '/produtoTipoAtributo/' + id,
                token: token,
            }).then(response => {
                //console.log(response.data.data[0]);
                setDados(response.data.data);
            }).catch(err => {
                //console.log(err)
            }).finally(() => { setIsLoading(false); });
        } else {
            setIsLoading(false);
        }
    };

    const salvar = () => {
        
        if (isSubmitting) {
            return;
        }

        setIsSubmitting(true);
if (id) {//update
            api({
                method: 'put',
                action: '/produtoTipoAtributo/' + id,
                token: token,
                data: dados
            })
                .then(function (response) {
                    toast.success("Dados salvos com sucesso!");
                    history.push("/produtoTipoAtributo");
                })
                .catch(function (error) {
                    toast.error('Erro ao salvar: ' + (error.response?.data?.error ?? error.message ?? ''));
                })
                .finally(() => {
                    setIsSubmitting(false);
                });
        } else {//insert
            api({
                method: 'post',
                action: '/produtoTipoAtributo',
                token: token,
                data: { ...dados, ...{ empresa: empresa } }
            })
                .then(function (response) {
                    toast.success("Dados salvos com sucesso!");
                    history.push("/produtoTipoAtributo");
                })
                .catch(function (error) {
                    toast.error('Erro ao salvar: ' + (error.response?.data?.error ?? error.message ?? ''));
                })
                .finally(() => {
                    setIsSubmitting(false);
                });
        }
    };

    useEffect(() => { //onload
        document.querySelector("#nome").focus(); //autofocus no nome
        buscar();
    }, 
    // eslint-disable-next-line
    []);

    return (
        <ErpTemplate processando={isLoading}>
            <div className="main-content container-fluid">
                <div className="page-title">
                    <h3>Tipo de Atributo</h3>
                </div>
                <section id="multiple-column-form">
                    <div className="row match-height">
                        <div className="col-sm-12">
                            <div className="card">
                                <div className="card-content">
                                    <div className="card-body">
                                        <form className="form" onSubmit={(e) => { salvar(); e.preventDefault(); }}>
                                            {/*<div className="row">
                                                <div className="col-sm-6">
                                                    <div className="form-floating form-group">
                                                        <input type="text" className="form-control form-control-lg" id="codigo" placeholder="Código"
                                                            value={dados.codigo}
                                                            onChange={e => setDados({ ...dados, ...{ "codigo": e.target.value } })}
                                                        />
                                                        <label htmlFor="floatingInput">Código</label>
                                                    </div>
                                                </div>
                                            </div>*/}
                                            <div className="row">
                                                <div className="col-sm-12">
                                                    <div className="form-floating form-group">
                                                        <input type="text" className="form-control form-control-lg" id="nome" placeholder="Nome"
                                                            value={dados.nome}
                                                            onChange={e => setDados({ ...dados, ...{ "nome": e.target.value } })}
                                                        />
                                                        <label htmlFor="floatingInput">Nome</label>
                                                    </div>
                                                </div>
                                                <div className="col-sm-12 d-flex justify-content-end">
                                                    <SaveButton isSubmitting={isSubmitting} />
                                                </div>
                                            </div>
                                        </form>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </div>
        </ErpTemplate>
    );
}